import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import './Errors.scss';

const NotFound = () => {
  return (
    <div className="error-page">
      <motion.div
        className="error-content"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <div className="error-actions">
          <Link to="/dashboard" className="btn btn-primary">
            <FiHome /> Go to Dashboard
          </Link>
          <button onClick={() => window.history.back()} className="btn btn-outline">
            <FiArrowLeft /> Go Back
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;